<article class="consult__patient" [attr.sticky]="sticky ? 'sticky' : null">
  <section class="page-container flex flex-column" *ngIf="patient">
    <div class="form__field flex-row align-items-center">
      <div class="col pl-0 py-0 inline-flex align-items-center">
        <div>
          <button pButton type="button" icon="fas fa-pencil-alt" class="p-button-warning p-button-outlined"
            [pTooltip]="screen.actions.editPatient" (click)="openPatientDialog()">
          </button>
        </div>
        <h2 class="consult__patient-heading flex-column md:flex-row" *ngIf="patient">
          {{patient.fullName}}<span *ngIf="patient.document">&nbsp;({{patient.document}})</span>
        </h2>
      </div>

      <span class="col-fixed px-0 py-0 hide-on-medium" [style.width.px]="300">
        {{patient.dateBorn | date : 'dd-MM-yyyy' : '+0000'}}{{patient.ageLabel}}
      </span>

      <span class="col-fixed pr-0 py-0 text-right hide-on-medium" [style.width.px]="125">
        {{patient.clinicHistory}}
      </span>
    </div>
    <div class="form__field flex-row flex-wrap hide-from-medium">
      <span class="col-12 md:col-6 px-0 md:pr-2 py-0">
        {{patient.dateBorn | date : 'dd-MM-yyyy' : '+0000'}}{{patient.ageLabel}}
      </span>

      <span class="col-12 md:col-6 px-0 md:pl-2 pb-0 md:pt-0">
        {{patient.clinicHistory}}
      </span>
    </div>
  </section>

  <div #saveButtons class="consult__sticky-buttons" [attr.sticky]="sticky ? 'sticky' : null">
    <div class="flex align-items-center justify-content-between consult__sticky-wrapper">
      <div class="consult__patient-heading-wrapper">
        <div class="inline-flex align-items-center">
          <button pButton type="button" icon="fas fa-pencil-alt" class="p-button-warning p-button-outlined"
            [pTooltip]="screen.actions.editPatient" (click)="openPatientDialog()">
          </button>
          <h2 class="consult__patient-heading" *ngIf="patient">
            {{patient.fullName}} <span *ngIf="patient.document">({{patient.document}})</span>
          </h2>
        </div>
      </div>
      <div class="consult__buttons">
        <button pButton type="button" icon="fas fa-print" class="p-button-info"
          [pTooltip]="screen.actions.generateHistory" tooltipPosition="left" (click)="save(true)"
          [disabled]="loading || saving">
        </button>
        <button pButton type="button" icon="far fa-save" class="p-button-info p-button-outlined"
          [label]="screen.actions.draft" (click)="save(false)" [disabled]="loading || saving" *ngIf="!edit">
        </button>
        <button pButton type="submit" icon="far fa-save" class="p-button-success p-button-outlined"
          [label]="screen.actions.save" [disabled]="loading || saving">
        </button>
      </div>
    </div>
  </div>
</article>

<ms-pdf-viewer [pdfFile]="historyPdf" [(show)]="showHistoryPdf"></ms-pdf-viewer>